import { get } from 'lodash';
import { images as iK } from 'src/tools/contentModulesFieldName';
import arrayMove from 'array-move';
import { generateResponsiveImage } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';
import { responsivePosterTypeDict } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';

const useImagePoster = ({ form }) => {
  const handleOnTypeChange = (type) => {
    const correctNum = responsivePosterTypeDict[type];
    const images = form.getFieldValue(iK) || [];
    const currentLen = images.length;
    if (currentLen > correctNum) {
      const newImages = images.slice(0, correctNum);
      form.setFieldsValue({ [iK]: newImages });
    } else if (currentLen < correctNum) {
      const diff = correctNum - currentLen;
      const a = [];
      for (let i = 0; i < diff; i++) {
        a.push(generateResponsiveImage(`Poster ${currentLen + i + 1}`));
      }
      form.setFieldsValue({ [iK]: [...images, ...a] });
    }
  };

  const handleOnModalConfirm = (data) => {
    const draggableId = get(data, 'draggableId');
    const images = form.getFieldValue(iK) || [];
    const nI = images.map((i) => {
      const iD = get(i, 'draggableId');
      if (iD === draggableId) {
        return { ...(i || {}), ...data };
      } else {
        return i;
      }
    });

    form.setFieldsValue({ [iK]: nI });
  };
  const handleOnAdd = (value, onChange) => {
    const pc = generateResponsiveImage('Poster');
    //const { pc } = ;
    onChange([...(value || []), pc]);
  };
  const handleOnDelete = (value, onChange, index) => {
    const nValue = (value || []).filter((_, i) => {
      return i !== index;
    });
    onChange(nValue);
  };
  const handleOnSort = (value, onChange, from, to) => {
    const nValue = arrayMove(value || [], from, to);
    onChange(nValue);
  };
  return {
    handleOnModalConfirm,
    handleOnAdd,
    handleOnDelete,
    handleOnSort,
    handleOnTypeChange,
  };
};
export { useImagePoster };
